import { render, staticRenderFns } from "./integralEdit.vue?vue&type=template&id=6b207072&scoped=true&"
import script from "./integralEdit.vue?vue&type=script&lang=js&"
export * from "./integralEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b207072",
  null
  
)

export default component.exports